/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

export type ListState = 'loading' | 'error' | 'empty' | 'list';

/**
 * Stato di una pagina elenco costruita su usePaginate. Il composable del core
 * inghiotte gli errori dell'API (response = {error: true}, senza meta): senza
 * questo controllo una chiamata fallita sembrerebbe un elenco vuoto.
 */
export const listState = (
  isLoading: boolean,
  response: {error?: boolean} | null | undefined,
  total: number,
): ListState => {
  if (isLoading) return 'loading';
  if (response?.error === true) return 'error';
  return total === 0 ? 'empty' : 'list';
};
